<p class="modal-title">Investment growth and risk</p>
<div class="modal-close" (click)="onClose()">
    <img alt="Close" src="../../../assets/icons/circle-x.svg" />
</div>
<p>What you select reflects your tolerance for investment risk - how comfortable you are knowing your funds may decrease
    due to market volatility. You may choose to invest aggressively before retirement, with the goal to increase your
    funds over the long term. And then invest conservatively during retirement for likely more stability when you'll
    want or need your savings.</p>